import React, {useState} from "react";
import {SearchIcon} from "@App/Components/common/Icons";
import {Generation} from "@App/types";
import {useVehicletree} from "@App/hooks/api/useVehicletree";
import {GenerationListItemGroup} from "@App/Components/Vehicletree/GenerationList";
import {GenerationListSkeleton} from "@App/Components/Vehicletree/GenerationList/GenerationListSkeleton";
import {useTranslation} from "react-i18next";

type GenerationListProps = {
    onClick: (generation: Generation) => void
}

export const GenerationList = React.memo<GenerationListProps>((props: GenerationListProps) => {

    const {t} = useTranslation()
    const [searchTerm, setSearchTerm] = useState('')
    const {loading, generations, error} = useVehicletree(false, true);

    const groupGenerationsByName = (generations: Generation[]) => {
        return generations.reduce((store, generation) => {
            const name = generation.name.split(' ')[0]
            const keyStore = (
                store[name] ||     // Does it exist in the object?
                (store[name] = []) // If not, create it as an empty array
            );
            keyStore.push(generation)

            return store
        }, {})
    }

    if (loading) {
        return (
            <GenerationListSkeleton/>
        )
    }

    if (error) {
        return <div>Error</div>
    }

    const getGenerations = () => {
        const filteredGenerations = generations && groupGenerationsByName(generations.filter(gen => gen.name.toLowerCase().includes(searchTerm.toLowerCase())))

        if (!filteredGenerations) {
            return
        }

        let rows = []
        for (const key in filteredGenerations) {
            rows.push(<GenerationListItemGroup key={key} name={key} group={filteredGenerations[key]}
                                               onClick={props.onClick}/>)
        }

        return rows
    }

    const editSearchTerm = (e) => {
        setSearchTerm(e.target.value)
    }

    return (
        <div>
            <div className="relative md:w-80 max-w-full">
                <input
                    value={searchTerm}
                    type="text"
                    placeholder={t('generationList.search-generation')}
                    className="focus:outline-none w-full border focus:border-primary border-neutral-500 py-2 px-3 pr-8 rounded"
                    onChange={editSearchTerm}
                />
                <SearchIcon className={'absolute top-2 right-2 w-6 h-6'}/>
            </div>
            <div className="mt-5">
                {getGenerations()}
            </div>
        </div>
    )
})
